var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"Footer"}},[_c('hr'),_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v("Powered by"),_c('strong',[_vm._v("CEPTINEL")])])])])
}]

export { render, staticRenderFns }